var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "62px",
    viewBox: "0 0 60 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "98C688C8-FBA3-4B93-96FE-F1808AA39626") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 59.9999 0 59.9999 62 0 62"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Help",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "General-Help-Page_V3",
    transform: "translate(-98.000000, -1359.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(66.000000, 1327.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "desktop",
    transform: "translate(32.000100, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,2 C13.431,2 0,15.431 0,32 C0,48.5685 13.431,62 30,62 C46.5685,62 60,48.5685 60,32 C60,15.431 46.5685,2 30,2 M30,3.5 C45.715,3.5 58.5,16.285 58.5,32 C58.5,47.715 45.715,60.5 30,60.5 C14.285,60.5 1.5,47.715 1.5,32 C1.5,16.285 14.285,3.5 30,3.5",
    id: "Fill-1",
    fill: "#EDEBE9",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-4",
    stroke: "#05314D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "36.10645 46.7666 40.35645 46.7666 19.14795 46.7666"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(12.499900, 17.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.85655,22.59985 L1.69005,22.59985 C0.86505,22.59985 0.19005,21.92485 0.19005,21.09985 L0.19005,1.76635 C0.19005,0.94185 0.86505,0.26635 1.69005,0.26635 L32.85655,0.26635 C33.68155,0.26635 34.35655,0.94185 34.35655,1.76635 L34.35655,21.09985 C34.35655,21.92485 33.68155,22.59985 32.85655,22.59985 Z",
    id: "Stroke-5",
    stroke: "#05314D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.23155,
    y1: 29.09985,
    x2: 13.85655,
    y2: 24.84985,
    id: "Stroke-7",
    stroke: "#05314D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.23155,
    y1: 29.09985,
    x2: 20.60655,
    y2: 24.84985,
    id: "Stroke-9",
    stroke: "#05314D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-11",
    stroke: "#05314D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "8.5653 11.0835 5.2948 10.997 5.3818 7.7265 8.6523 7.813"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-13",
    stroke: "#05314D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "8.3292 18.7959 5.0587 18.7094 5.1457 15.4389 8.4157 15.5254"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.2711,
    y1: 3.97435,
    x2: 0.4361,
    y2: 3.97435,
    id: "Stroke-15",
    stroke: "#05314D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.85095,
    y1: 9.31395,
    x2: 11.68645,
    y2: 9.31395,
    id: "Stroke-17",
    stroke: "#05314D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.85095,
    y1: 17.27415,
    x2: 11.68645,
    y2: 17.27415,
    id: "Stroke-19",
    stroke: "#05314D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9425,2.15065 C2.9425,2.10965 2.9095,2.07665 2.8685,2.07665 C2.8275,2.07665 2.7945,2.10965 2.7945,2.15065 C2.7945,2.19165 2.8275,2.22465 2.8685,2.22465 C2.9095,2.22465 2.9425,2.19165 2.9425,2.15065 Z",
    id: "Stroke-21",
    stroke: "#05314D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.90025,2.15065 C4.90025,2.10965 4.86725,2.07665 4.82625,2.07665 C4.78525,2.07665 4.75225,2.10965 4.75225,2.15065 C4.75225,2.19165 4.78525,2.22465 4.82625,2.22465 C4.86725,2.22465 4.90025,2.19165 4.90025,2.15065 Z",
    id: "Stroke-23",
    stroke: "#05314D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.952,2.15065 C6.952,2.10965 6.919,2.07665 6.878,2.07665 C6.837,2.07665 6.804,2.10965 6.804,2.15065 C6.804,2.19165 6.837,2.22465 6.878,2.22465 C6.919,2.22465 6.952,2.19165 6.952,2.15065 Z",
    id: "Stroke-25",
    stroke: "#05314D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-27",
    fill: "#05314D",
    points: "11.1749 13.65845 10.3004 14.53295 8.6554 12.88795 9.5299 12.01345"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-29",
    fill: "#05314D",
    points: "6.87145 10.2295 8.02545 13.5185 10.16045 11.3835"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.db3de6187d48e09d4a1f5b956bfe759b.svg";
export { ForwardRef as ReactComponent };